export default "__VITE_ASSET__ndkJYsCa__"